module.exports = __webpack_public_path__ + "static/media/integrations.33d1002d.webp";